import * as React from "react";
import Header from "components/layout/Header/Header";
import Footer from "components/layout/Footer/Footer";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FunctionComponent<MainLayoutProps> = ({ children }) => {
  return (
    <>
      <Header />
      <div className="main" role="main">
        {children}
      </div>
      <Footer />
    </>
  );
};
